var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleGreenAqua(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35a6bf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.9,16.67H4.23v.83a.82.82,0,0,1-.83.83H2.57A.81.81,0,0,1,2,18.09a.83.83,0,0,1-.25-.59V9.17L3.8,4.34a1.63,1.63,0,0,1,.62-.73,1.65,1.65,0,0,1,.91-.28H14.8a1.67,1.67,0,0,1,1.53,1L18.4,9.17V17.5a.87.87,0,0,1-.24.59.82.82,0,0,1-.59.24h-.84a.82.82,0,0,1-.59-.24.87.87,0,0,1-.24-.59Zm.83-5.84H3.4V15H16.73ZM3.55,9.17h13L14.8,5H5.33L3.55,9.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.5,12.34h9.13v1.25H5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleGreenAqua);
export default __webpack_public_path__ + "static/media/vehicle-green-aqua.e085ca7e46a9378bef40bfaddda2121c.svg";
export { ForwardRef as ReactComponent };